var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconGroup',[_vm._t("default"),(!_vm.mnemonicBackedUp)?_c('span',{staticClass:"warning-icon"},[_vm._v("!")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }